
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.181 2.28a.272.272 0 00-.39 0L4.729 8.25l-.278 2.546c-.055.329.25.63.584.575l2.587-.274 6.063-5.97a.262.262 0 000-.383L11.181 2.28zm4.506-.63L14.324.308a1.104 1.104 0 00-1.53 0l-.973.958a.262.262 0 000 .384l2.503 2.464c.111.11.278.11.39 0l.973-.958a1.063 1.063 0 000-1.506zm-5.006 7.832v2.765h-8.9V3.485H8.15c.11 0 .194-.028.25-.083l1.112-1.095c.195-.219.056-.575-.25-.575H1.335C.585 1.732 0 2.334 0 3.046v9.64C0 13.425.584 14 1.335 14h9.79c.724 0 1.336-.575 1.336-1.314v-4.3c0-.3-.362-.438-.584-.246l-1.113 1.095c-.056.055-.083.137-.083.247z","fill":"currentColor"}})])
          )
        }
      }
    